export default __webpack_public_path__ + "static/linkBg8-32c22ba31ea032f0b03829111c3d5c90.png";